import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTmm = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 9C9.65113 9 11 7.69137 11 6.08992C11 4.1559 8 1 8 1C8 1 5 4.1559 5 6.08992C5 7.69137 6.34887 9 8 9Z",
			fill: "currentColor",
			fillOpacity: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.63 10.375H14.37C14.4415 10.375 14.5 10.4336 14.5 10.5052V11.8073C14.5 11.8789 14.4415 11.9375 14.37 11.9375H1.63C1.5585 11.9375 1.5 11.8789 1.5 11.8073V10.5052C1.5 10.4336 1.5585 10.375 1.63 10.375Z",
			fill: "currentColor",
			fillOpacity: 1
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.63 13.5H14.37C14.4415 13.5 14.5 13.5586 14.5 13.6302V14.9323C14.5 15.0039 14.4415 15.0625 14.37 15.0625H1.63C1.5585 15.0625 1.5 15.0039 1.5 14.9323V13.6302C1.5 13.5586 1.5585 13.5 1.63 13.5Z",
			fill: "currentColor",
			fillOpacity: 1
		})
	]
});
export default SvgTmm;
